const OFFLINE_CONTEXT_KEY = "schoola_offline_context_v1";
const OFFLINE_LOGOUT_BYPASS_KEY = "schoola_offline_logout_bypass";

function safeParse(value) {
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
}

function readUser() {
  return safeParse(localStorage.getItem("user"));
}

export function getStoredOfflineContext() {
  return safeParse(localStorage.getItem(OFFLINE_CONTEXT_KEY)) || {};
}

export function setStoredOfflineContext(patch = {}) {
  const next = {
    ...getStoredOfflineContext(),
    ...patch,
  };
  localStorage.setItem(OFFLINE_CONTEXT_KEY, JSON.stringify(next));
  return next;
}

export function clearStoredOfflineContext() {
  localStorage.removeItem(OFFLINE_CONTEXT_KEY);
}

export function getOfflineContext(state) {
  const stored = getStoredOfflineContext();
  const user = state?.auth?.user || readUser();

  return {
    userId: user?.id ?? stored.userId ?? null,
    schoolId: user?.current_school_id ?? stored.schoolId ?? null,
    sessionId: stored.sessionId ?? null,
    termId: stored.termId ?? null,
  };
}

export function updateOfflineContextFromAuth(state) {
  const ctx = getOfflineContext(state);
  return setStoredOfflineContext(ctx);
}

export function setOfflineTermSession({ termId = null, sessionId = null } = {}) {
  return setStoredOfflineContext({
    ...(termId ? { termId } : {}),
    ...(sessionId ? { sessionId } : {}),
  });
}

export function getOfflineTermId(state) {
  return getOfflineContext(state).termId ?? null;
}

export function getOfflineNamespace(state) {
  const ctx = getOfflineContext(state);
  return {
    schoolId: ctx.schoolId,
    userId: ctx.userId,
    sessionId: ctx.sessionId,
    termId: ctx.termId,
  };
}

export function setLogoutBypass(value) {
  if (value) {
    localStorage.setItem(OFFLINE_LOGOUT_BYPASS_KEY, "1");
  } else {
    localStorage.removeItem(OFFLINE_LOGOUT_BYPASS_KEY);
  }
}

export function getLogoutBypass() {
  return localStorage.getItem(OFFLINE_LOGOUT_BYPASS_KEY) === "1";
}
